/*
 * @Author: shiguang
 * @Date: 2023-04-28 12:30:18
 * @LastEditors: yusha
 * @LastEditTime: 2024-04-20 19:00:03
 * @Description: CKBLayout
 */

import qs from 'query-string';
import FloatToolbar from '@/components/FloatToolbar';
import CKBHeader from './modules/CKBHeader';
import MenuList from './modules/MenuList';
import './index.css';
export interface CKBLayoutProps {
    children?: React.ReactNode;
    isShowMenu?: boolean;
    isShowHeader?: boolean;
}
const CKBLayout: React.FC<CKBLayoutProps> = (props: CKBLayoutProps) => {
    const { children, isShowMenu, isShowHeader = true } = props;
    const { pathname, search } = window.location;
    if (!isShowHeader) {
        return <>{children}</>;
    }
    const { from } = qs.parse(search);
    const isSpecial =
        pathname.includes('/oem/utility/InterLogistics') && from === 'detail';

    return (
        <div className="bg-[#f8f8f8]">
            <CKBHeader />
            <FloatToolbar />
            <div
                className="flex"
                style={{
                    height: 'calc(100vh - 32px)'
                }}
            >
                {isShowMenu !== false && <MenuList />}
                <div
                    className={`p-[20px] ${isSpecial ? 'pb-0' : ''}`}
                    style={{
                        overflowY: 'scroll',
                        flexGrow: 2,
                        backgroundColor: '#F8F8F8'
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};
export default CKBLayout;
